import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonFr from './locales/fr/common.json';
import authFr from './locales/fr/auth.json';
import messagesFr from './locales/fr/messages.json';
import validationFr from './locales/fr/validation.json';
import dashboardFr from './locales/fr/dashboard.json';
import organisationsFr from './locales/fr/organisations.json';
import projectsFr from './locales/fr/projects.json';
import deploymentsFr from './locales/fr/deployments.json';
import buildsFr from './locales/fr/builds.json';
import backupsFr from './locales/fr/backups.json';
import profileFr from './locales/fr/profile.json';
import statusFr from './locales/fr/status.json';
import auditFr from './locales/fr/audit.json';
import monitoringFr from './locales/fr/monitoring.json';
import invitationFr from './locales/fr/invitation.json';
import nubis3Fr from './locales/fr/nubis3.json';
import blueprintsFr from './locales/fr/blueprints.json';
import nubieaiFr from './locales/fr/nubieai.json';
import mcpFr from './locales/fr/mcp.json';

import commonEn from './locales/en/common.json';
import authEn from './locales/en/auth.json';
import messagesEn from './locales/en/messages.json';
import validationEn from './locales/en/validation.json';
import dashboardEn from './locales/en/dashboard.json';
import organisationsEn from './locales/en/organisations.json';
import projectsEn from './locales/en/projects.json';
import deploymentsEn from './locales/en/deployments.json';
import buildsEn from './locales/en/builds.json';
import backupsEn from './locales/en/backups.json';
import profileEn from './locales/en/profile.json';
import statusEn from './locales/en/status.json';
import auditEn from './locales/en/audit.json';
import monitoringEn from './locales/en/monitoring.json';
import invitationEn from './locales/en/invitation.json';
import nubis3En from './locales/en/nubis3.json';
import blueprintsEn from './locales/en/blueprints.json';
import nubieaiEn from './locales/en/nubieai.json';
import mcpEn from './locales/en/mcp.json';

const resources = {
  fr: {
    common: commonFr,
    auth: authFr,
    messages: messagesFr,
    validation: validationFr,
    dashboard: dashboardFr,
    organisations: organisationsFr,
    projects: projectsFr,
    deployments: deploymentsFr,
    builds: buildsFr,
    backups: backupsFr,
    profile: profileFr,
    status: statusFr,
    audit: auditFr,
    monitoring: monitoringFr,
    invitation: invitationFr,
    nubis3: nubis3Fr,
    blueprints: blueprintsFr,
    nubieai: nubieaiFr,
    mcp: mcpFr,
  },
  en: {
    common: commonEn,
    auth: authEn,
    messages: messagesEn,
    validation: validationEn,
    dashboard: dashboardEn,
    organisations: organisationsEn,
    projects: projectsEn,
    deployments: deploymentsEn,
    builds: buildsEn,
    backups: backupsEn,
    profile: profileEn,
    status: statusEn,
    audit: auditEn,
    monitoring: monitoringEn,
    invitation: invitationEn,
    nubis3: nubis3En,
    blueprints: blueprintsEn,
    nubieai: nubieaiEn,
    mcp: mcpEn,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    defaultNS: 'common',
    ns: ['common', 'auth', 'messages', 'validation', 'dashboard', 'organisations', 'projects', 'deployments', 'builds', 'backups', 'profile', 'status', 'audit', 'monitoring', 'invitation', 'nubis3', 'blueprints', 'nubieai', 'mcp'],
    returnNull: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

// Cast en any pour court-circuiter la recursion de types de i18next 23 sur
// les appels `i18n.t('key', { ns: 'xxx' })` (voir src/i18next.d.ts pour le
// contexte). A retirer quand le typage par-namespace sera fait en Phase 1.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default i18n as any;
